import ApiCallManager from '../models/apiCallManager';
import Media from '../models/media';

/**
 * @ngdoc service
 * @name profileService
 * @description
 * This service is meant to fetch all the user media.
 *
 * @memberof common
 */
class ProfileService extends ApiCallManager {
  /**
   * Class constructor.
   * @param {Service} appUtils             The service to get the page query param.
   * @param {Service} contentCreatorAppAPI The service to fetch the user media.
   * @ignore
   */
  constructor(appUtils, contentCreatorAppAPI) {
    'ngInject';

    super(
      appUtils,
      (content) => content.map((item) => new Media(item)),
      contentCreatorAppAPI.getUserMedia.bind(contentCreatorAppAPI),
    );
  }
  /**
   * Get the Media list from the BE.
   * @param {Boolean} refresh flag to force a refresh of the Media.
   * @return {Promise}
   */
  getMedia(refresh) {
    return this._getContent(refresh);
  }
  /**
   * Get a Media by its Id.
   * @return {Promise}
   */
  getMediaById(mediaId) {
    return this._getContentById(mediaId);
  }
}

export default ProfileService;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/services/profile.js